const common = {
  common: {
    loading: "加载中...",
    error: "出错了",
    success: "成功",
    cancel: "取消",
    confirm: "确认",
    submit: "提交",
    save: "保存",
    edit: "编辑",
    delete: "删除",
    search: "搜索",
    filter: "筛选",
    moreInfo: "更多信息",
    lessInfo: "收起信息",
    previous: "上一页",
    next: "下一页",
    back: "返回",
    create: "创建",
    retry: "重试",
  },
  
  general: {
    back: "返回",
    cancel: "取消",
    confirm: "确认",
    error: "错误",
    loadingText: "加载中...",
    noSearchResults: "没有符合搜索条件的结果",
    retry: "重试",
    search: "搜索",
  },
};

export default common; 